import React from "react";
import { translations } from "../translations";

const ViolationWarningModal = ({ attemptsLeft, onContinue, lang }) => {
  const t = translations[lang] || translations.en;

  return (
    <div className="modal-backdrop">
      <div className="modal violation-modal">
        <div className="modal-icon-ring danger">⚠️</div>
        <h2 className="modal-title danger-text">{t.violationTitle}</h2>
        <p className="modal-instruction">{t.violationMessage}</p>

        <div className="attempts-box">
          <p className="attempts-label">{t.attemptsLeft}</p>
          <p className="attempts-count">{attemptsLeft}</p>
        </div>

        <p className="violation-warning-text">{t.violationWarning}</p>

        <div className="modal-actions">
          <button type="button" className="btn-dark btn-lg" onClick={onContinue}>
            {t.continueExam}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViolationWarningModal;
